// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"10":"31d6cfe0","469":"c047c163","480":"31d6cfe0","967":"31d6cfe0"}[chunkId] + ".chunk.css";
};